import React, { FC } from 'react';
import { formatClassName, pickDataAttributes } from '../../utils';

export type ProgressSpinnerProps = {
  size?: 'xs' | 'sm' | 'lg' | 'xl' | 'xxl';
  color?:
    | 'amber'
    | 'blue'
    | 'bluegray'
    | 'gray'
    | 'green'
    | 'pink'
    | 'primary'
    | 'purple'
    | 'red'
    | 'teal'
    | 'white'
    | 'yellow';
  classNames?: string;
  containerClassName?: string;
  pageLoader?: boolean;
};

export const ProgressSpinner: FC<ProgressSpinnerProps> = props => {
  const { classNames, color = 'primary', containerClassName, pageLoader, size = 'xl' } = props;

  const dataAttributes = pickDataAttributes(props, 'progress-spinner');
  const styles = classNames || `preloader pl-${size} pls-${color}`;
  const containerStyles = containerClassName || (pageLoader ? 'page-loader' : 'preloader-container');

  if (typeof document !== 'undefined' && !pageLoader) {
    const body = document.querySelector('body');

    if (body?.className.includes('loading')) {
      body.className = body.className.replace('loading', '');
    }
  }

  return (
    <div className={formatClassName([containerStyles, 'd-print-none'])}>
      <div className={styles} {...dataAttributes}>
        <svg className="pl-circular" viewBox="25 25 50 50">
          <circle className="plc-path" cx="50" cy="50" r="20" />
        </svg>
      </div>
    </div>
  );
};

ProgressSpinner.displayName = 'ProgressSpinner';
